"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    brandOffice: function() {
        return brandOffice;
    },
    brandTeams: function() {
        return brandTeams;
    },
    brandTeamsV21: function() {
        return brandTeamsV21;
    },
    brandWeb: function() {
        return brandWeb;
    }
});
const brandWeb = {
    10: `#061724`,
    20: `#082338`,
    30: `#0a2e4a`,
    40: `#0c3b5e`,
    50: `#0e4775`,
    60: `#0f548c`,
    70: `#115ea3`,
    80: `#0f6cbd`,
    90: `#2886de`,
    100: `#479ef5`,
    110: `#62abf5`,
    120: `#77b7f7`,
    130: `#96c6fa`,
    140: `#b4d6fa`,
    150: `#cfe4fa`,
    160: `#ebf3fc`
};
const brandTeams = {
    10: `#2b2b40`,
    20: `#2f2f4a`,
    30: `#333357`,
    40: `#383966`,
    50: `#3d3e78`,
    60: `#444791`,
    70: `#4f52b2`,
    80: `#5b5fc7`,
    90: `#7579eb`,
    100: `#7f85f5`,
    110: `#9299f7`,
    120: `#aab1fa`,
    130: `#b6bcfa`,
    140: `#c5cbfa`,
    150: `#dce0fa`,
    160: `#e8ebfa`
};
const brandOffice = {
    10: `#29130b`,
    20: `#4d2415`,
    30: `#792000`,
    40: `#99482b`,
    50: `#a52c00`,
    60: `#c33400`,
    70: `#e06a3f`,
    80: `#d83b01`,
    90: `#dd4f1b`,
    100: `#fe7948`,
    110: `#ff865a`,
    120: `#ff9973`,
    130: `#e8825d`,
    140: `#ffb498`,
    150: `#f4beaa`,
    160: `#f9dcd1`
};
const brandTeamsV21 = {
    10: `#29274f`,
    20: `#2f2a5e`,
    30: `#352e70`,
    40: `#3b3185`,
    50: `#44359e`,
    60: `#4d3aba`,
    70: `#5a40db`,
    80: `#654cf5`,
    90: `#7769fa`,
    100: `#887dff`,
    110: `#9791ff`,
    120: `#aba8ff`,
    130: `#bab8ff`,
    140: `#c8c7ff`,
    150: `#dcdbff`,
    160: `#e8e8ff`
};
